import classNames from 'classnames';

import Typography from '../../core/Typography';
import CardImage from '../base/CardImage';

import useStyles from './styles';
import ICardImageSection from './types';

function CardImageSection({
  items,
  title,
  label,
  className,
  titleFontcolor,
  titleElement = 'h2',
}: ICardImageSection) {
  const classes = useStyles();

  return (
    <section className={classNames(classes.container, className)}>
      <div className={classes.root}>
        <header className={classes.header}>
          {label && (
            <Typography className={classes.label} element="h3" look="body-large">
              {label}
            </Typography>
          )}
          <Typography
            className={classes.title}
            element={titleElement}
            color={titleFontcolor}
            look="h3"
          >
            {title}
          </Typography>
        </header>

        <ul className={classes.list}>
          {items.map(({ title: cardTitle, description, media, href }, index) => (
            <li key={index} className={classes.listItem}>
              {href ? (
                <a className={classes.cardLink} href={href}>
                  <CardImage title={cardTitle} description={description} media={media} />
                </a>
              ) : (
                <CardImage title={cardTitle} description={description} media={media} />
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default CardImageSection;
